import i18n, { type Resource } from 'i18next';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

const files = import.meta.glob<{ default: Record<string, unknown> }>('../locales/*/*.json', {
  eager: true,
});

const resources: Resource = {};

for (const [path, module] of Object.entries(files)) {
  const match = /\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
  if (!match) continue;
  const [, locale, namespace] = match as unknown as [string, string, string];
  resources[locale] ??= {};
  resources[locale][namespace] = module.default;
}

void i18n.use(ICU).use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'give',
  ns: Object.keys(resources['en'] ?? {}),
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
